/* ==================================================
  c_web-limited.js — 購入制限（Web限定）判定の共有ヘルパー
  spec: shopify_metafields_設計書 §1'.2 / 03_客注モード_FE §2.6

  SKU は次のいずれかに該当すれば購入制限対象（OR）:
    1. 商品の店舗受取可否フラグ = false
    2. SKU の店舗受取可否フラグ = false
    3. 当日（JST） >= SKU のバーゲン開始日 − N（N = shop tabio.bargain_restriction_days、N <= 0 は不適用）
    4. 当日（JST） >= SKU の客注STOP日
    5. SKU がセール価格（比較価格があり販売価格がそれより安い）。snippet 側で SKU フラグ false として出力済み
  フラグは false のみ「不可」。true・空・未設定は「可」。在庫は見ない。

  判定データは snippets/c_web-limited-data.liquid が data-web-limited 属性に出力する
  （メタフィールドのキーはその snippet だけが持つ）。形式:
    { "p": 商品フラグ, "a": [全バリアント ID], "v": { "<バリアント ID>": [フラグ, バーゲン開始日, 客注STOP日] } }
  3・4 はバックエンドのバッチが判定して SKU フラグに畳み込むため、現在の snippet は日付を出さない（常に null）。
  日付の判定はキャッシュ済みの旧ページ用に残している（当日日付は JST でここで求める）。

  - ビルド工程なしの IIFE。window.CWebLimited だけを公開する。
  - 表示・カート追加の制限は客注モードのときだけ（isStaffMode）。ゲートは各呼び出し側で行う。
  ===================================================*/
(function () {
  'use strict';

  if (window.CWebLimited) return;

  var JST_OFFSET_MS = 9 * 60 * 60 * 1000;   // 日本は夏時間なし
  var DATE_RE = /^(\d{4})-(\d{2})-(\d{2})/;

  /* 'YYYY-MM-DD'（JST の当日）。now 省略時は現在時刻。 */
  function todayJST(now) {
    var d = now instanceof Date ? now : new Date();
    return new Date(d.getTime() + JST_OFFSET_MS).toISOString().slice(0, 10);
  }

  /* 日付値を 'YYYY-MM-DD' に正規化。不正・空は ''。 */
  function normalizeDate(value) {
    if (value == null) return '';
    var m = DATE_RE.exec(String(value).trim());
    if (!m) return '';
    var y = Number(m[1]);
    var mo = Number(m[2]);
    var d = Number(m[3]);
    var t = new Date(Date.UTC(y, mo - 1, d));
    if (t.getUTCFullYear() !== y || t.getUTCMonth() !== mo - 1 || t.getUTCDate() !== d) return '';
    return m[1] + '-' + m[2] + '-' + m[3];
  }

  /* 'YYYY-MM-DD' を days 日ずらす（暦日。時刻は扱わない）。 */
  function addDays(ymd, days) {
    var m = DATE_RE.exec(ymd);
    var t = new Date(Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3]) + days));
    return t.toISOString().slice(0, 10);
  }

  /* 店舗受取可否フラグ: false（または文字列 'false'）だけが「不可」。 */
  function isFlagOff(value) {
    if (value === false) return true;
    return typeof value === 'string' && value.trim().toLowerCase() === 'false';
  }

  function toDays(value) {
    var n = parseInt(value, 10);
    return isNaN(n) ? 0 : n;
  }

  function isBargainRestricted(bargainDate, days, today) {
    var start = normalizeDate(bargainDate);
    if (!start || days <= 0) return false;
    return today >= addDays(start, -days);
  }

  function isStopReached(stopDate, today) {
    var stop = normalizeDate(stopDate);
    return !!stop && today >= stop;
  }

  /* ctx の既定値を埋める: today = JST 当日, days = <body data-shop-bargain-restriction-days>。 */
  function resolveContext(ctx) {
    ctx = ctx || {};
    var today = ctx.today ? normalizeDate(ctx.today) : todayJST(ctx.now);
    var days = ctx.days != null ? toDays(ctx.days) : shopRestrictionDays();
    return { today: today, days: days };
  }

  /* 1 SKU の判定。data が無い（判定データ未取得）場合は「可」。 */
  function isVariantRestricted(data, variantId, ctx) {
    if (!data) return false;
    if (isFlagOff(data.p)) return true;
    var entry = data.v && variantId != null ? data.v[String(variantId)] : null;
    if (!entry) return false;
    var c = resolveContext(ctx);
    return isFlagOff(entry[0]) ||
      isBargainRestricted(entry[1], c.days, c.today) ||
      isStopReached(entry[2], c.today);
  }

  /* 商品一覧の判定: 全バリアントを対象に 'all' | 'partial' | 'none'。 */
  function productStatus(data, ctx) {
    if (!data) return 'none';
    if (isFlagOff(data.p)) return 'all';
    var ids = Array.isArray(data.a) && data.a.length ? data.a : Object.keys(data.v || {});
    if (!ids.length) return 'none';
    var c = resolveContext(ctx);
    var restricted = 0;
    for (var i = 0; i < ids.length; i++) {
      if (isVariantRestricted(data, ids[i], c)) restricted++;
    }
    if (restricted === 0) return 'none';
    return restricted === ids.length ? 'all' : 'partial';
  }

  /* data-web-limited 属性値（JSON）を読む。壊れていれば null。 */
  function parse(raw) {
    if (!raw) return null;
    if (typeof raw === 'object') return raw;
    try {
      var data = JSON.parse(raw);
      return data && typeof data === 'object' ? data : null;
    } catch (e) {
      return null;
    }
  }

  /* ---- バリアント ID → 判定データ の登録簿（カート追加の制限で使う） ---- */
  var byVariant = {};

  function register(data) {
    if (!data) return;
    var ids = Array.isArray(data.a) ? data.a : Object.keys(data.v || {});
    for (var i = 0; i < ids.length; i++) byVariant[String(ids[i])] = data;
  }

  /* root 配下の [data-web-limited] を登録する。parse 済みの要素は再解析しない。 */
  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var list = scope.querySelectorAll('[data-web-limited]');
    for (var i = 0; i < list.length; i++) {
      var el = list[i];
      var raw = el.getAttribute('data-web-limited');
      if (el.__cWebLimitedRaw === raw) continue;
      el.__cWebLimitedRaw = raw;
      el.__cWebLimitedData = parse(raw);
      register(el.__cWebLimitedData);
    }
  }

  /* 要素に付いた判定データ（parse 結果をキャッシュ）。 */
  function dataOf(el) {
    if (!el || !el.getAttribute) return null;
    var raw = el.getAttribute('data-web-limited');
    if (el.__cWebLimitedRaw !== raw) {
      el.__cWebLimitedRaw = raw;
      el.__cWebLimitedData = parse(raw);
      register(el.__cWebLimitedData);
    }
    return el.__cWebLimitedData;
  }

  /* 登録済みならその判定データ、未登録なら null（= 不明）。 */
  function lookup(variantId) {
    if (variantId == null) return null;
    return byVariant[String(variantId)] || null;
  }

  function hasVariant(data, variantId) {
    if (!data || !Array.isArray(data.a)) return false;
    for (var i = 0; i < data.a.length; i++) {
      if (String(data.a[i]) === String(variantId)) return true;
    }
    return false;
  }

  /* el の祖先で variantId を含む判定データを優先し（後から差し込まれるクイック購入なども拾う）、
     無ければページ全体の登録簿を引く。見つからなければ null（= 不明）。 */
  function dataFor(el, variantId) {
    var node = el && el.closest ? el.closest('[data-web-limited]') : null;
    while (node) {
      var data = dataOf(node);
      if (hasVariant(data, variantId)) return data;
      node = node.parentElement ? node.parentElement.closest('[data-web-limited]') : null;
    }
    var found = lookup(variantId);
    if (found) return found;
    if (typeof document !== 'undefined' && document.querySelectorAll) scan(document);
    return lookup(variantId);
  }

  function shopRestrictionDays() {
    var body = typeof document !== 'undefined' ? document.body : null;
    return toDays(body && body.dataset ? body.dataset.shopBargainRestrictionDays : 0);
  }

  function isStaffMode() {
    try {
      return !!(window.CStaffSession && window.CStaffSession.getToken());
    } catch (e) {
      return false;
    }
  }

  /* ラベル文言（locale → <body data-web-limited-text / data-web-limited-partial-text>）。 */
  function labels() {
    var ds = typeof document !== 'undefined' && document.body ? document.body.dataset : {};
    return {
      all: ds.webLimitedText || 'Web限定',
      partial: ds.webLimitedPartialText || '一部Web限定'
    };
  }

  /* ---- 商品カードのラベル（spec §2.6.3 実装メモ） ----
     機能タグの行とは別の専用の行に出す（ピルの見た目は assets/c_theme.css の .c_label--web-limited）。
     行は機能タグの行（テーマ: .c_product-item__info__head / Boost: .c_product-item__info__head__labels）の
     直後、タグが無いカードでは anchor（ブランド名・商品名ブロック）の直前に作り、ラベルを消すときは行ごと消す。 */
  var ROW_ATTR = 'data-web-limited-row';
  var LABEL_ATTR = 'data-web-limited-label';
  var TAG_ROW = '.c_product-item__info__head, .c_product-item__info__head__labels';

  function ensureLabelRow(card, anchorSelector) {
    var row = card.querySelector('[' + ROW_ATTR + ']');
    if (row) return row;
    var tags = card.querySelector(TAG_ROW);
    var anchor = anchorSelector ? card.querySelector(anchorSelector) : null;
    var parent = tags ? tags.parentNode : anchor && anchor.parentNode;
    if (!parent) return null;
    row = document.createElement('div');
    row.className = 'c_web-limited-row';
    row.setAttribute(ROW_ATTR, '');
    parent.insertBefore(row, tags ? tags.nextSibling : anchor);
    return row;
  }

  /* status: 'all' | 'partial' | 'none'。何度呼んでも同じ結果になる。 */
  function paintCardLabel(card, status, anchorSelector) {
    if (!card || !card.querySelector) return;
    var row = card.querySelector('[' + ROW_ATTR + ']');
    if (status !== 'all' && status !== 'partial') {
      if (row && row.parentNode) row.parentNode.removeChild(row);
      return;
    }
    var text = status === 'all' ? labels().all : labels().partial;
    row = ensureLabelRow(card, anchorSelector);
    if (!row) return;
    var label = row.querySelector('[' + LABEL_ATTR + ']');
    if (!label) {
      label = document.createElement('span');
      label.className = 'c_label--web-limited';
      row.appendChild(label);
    }
    if (label.textContent !== text) label.textContent = text;
    label.setAttribute(LABEL_ATTR, status);
  }

  window.CWebLimited = {
    paintCardLabel: paintCardLabel,
    todayJST: todayJST,
    normalizeDate: normalizeDate,
    isFlagOff: isFlagOff,
    isVariantRestricted: isVariantRestricted,
    productStatus: productStatus,
    parse: parse,
    register: register,
    scan: scan,
    dataOf: dataOf,
    lookup: lookup,
    dataFor: dataFor,
    isStaffMode: isStaffMode,
    labels: labels
  };
})();
